<template>
  <div class="supplierAgent-base">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "supplierAgentBase",
};
</script>
